import PropTypes from 'prop-types';
import React from 'react';
import './Homenet360.scss';

class Homenet360Component extends React.Component {
	componentDidMount() {
		const { trackGa } = this.props;

		if (typeof FYU !== 'undefined') {
			const { fyuseUid } = this.props;
			if (fyuseUid && fyuseUid.length) {
				/* eslint no-undef: 0 */
				// Specs: http://fyu.se/api/specs/web/viewer.html
				// Loading states: init, load, complete, & error
				FYU.add(fyuseUid, 'spin360', {
					autoplay: 0,
					zoom: 1,
					preload: 1,
					nologo: 1,
					nooverlay: 0,
					fullscreen: 0
				})
					.on('load', () => {
						// Attach tracking event handlers
						const spinCanvas = document.querySelector(
							'.fyu-renderer .fyu-canvas'
						);
						if (spinCanvas) {
							spinCanvas.addEventListener('mousedown', () =>
								trackGa({
									element: 'Homenet 360 Spin Content',
									result: 'Clicks or rotates content',
									widgetState: 'Gallery Modal'
								})
							);
							// Mobile
							spinCanvas.addEventListener('touchstart', () =>
								trackGa({
									element: 'Homenet 360 Spin Content',
									result: 'Clicks or rotates content',
									widgetState: 'Gallery Modal'
								})
							);
						}

						const tagIcon = document.querySelector('a.fyubtn.tags');
						if (tagIcon) {
							tagIcon.addEventListener('mousedown', () =>
								trackGa({
									element: 'Homenet 360 Tag Button',
									result: 'Toggles thumbnail links to tagged content',
									widgetState: 'Gallery Modal'
								})
							);
						}

						const tagsOverlay = document.querySelector(
							'.fyuse_tags_container'
						);
						if (tagsOverlay) {
							tagsOverlay.addEventListener('mousedown', () =>
								trackGa({
									element: 'Homenet 360 Spin Content',
									result: 'Clicks or rotates content showing tag thumbnails',
									widgetState: 'Gallery Modal'
								})
							);
							// Mobile
							tagsOverlay.addEventListener('touchstart', () =>
								trackGa({
									element: 'Homenet 360 Spin Content',
									result: 'Clicks or rotates content showing tag thumbnails',
									widgetState: 'Gallery Modal'
								})
							);
						}

						const container =
							document.querySelector('.fyu_container');
						if (container) {
							container.addEventListener('dblclick', () =>
								trackGa({
									element: 'Homenet 360 Spin Content',
									result: 'Zoom In/Out',
									widgetState: 'Gallery Modal'
								})
							);
						}
					})
					.on('complete', () => {
						// Wait until tags are loaded
						const taggedContent =
							document.querySelectorAll('.fyuse_tag a');
						if (taggedContent) {
							taggedContent.forEach((e) => {
								e.addEventListener('mousedown', () =>
									trackGa({
										element: 'Homenet 360 Tag',
										result: 'Displays tagged content (photo/spin)',
										widgetState: 'Gallery Modal'
									})
								);
							});
						}
					});
			}
		}
	}

	componentDidUpdate(prevProps) {
		// This is a hack to trigger a resize event to get the canvas to redraw
		// after clicking away from it and back again
		if (
			prevProps.modalSettings.spin360IsOpen !==
				this.props.modalSettings.spin360IsOpen &&
			this.props.modalSettings.spin360IsOpen
		) {
			const evt = window.document.createEvent('UIEvents');
			evt.initUIEvent('resize', true, false, window, 0);
			window.dispatchEvent(evt);
		}
	}

	render() {
		const {
			modalSettings: { spin360IsOpen },
			fyuseUid
		} = this.props;

		if (fyuseUid && fyuseUid.length) {
			const baseClassNames = [
				'h-100',
				'd-flex',
				'justify-content-center',
				'align-items-center'
			];

			const wrapperClassNames = new Set([
				...baseClassNames,
				...['spin360-container', 'py-5']
			]);

			if (!spin360IsOpen) {
				wrapperClassNames.add('hide');
				wrapperClassNames.delete('d-flex');
			} else {
				wrapperClassNames.delete('hide');
				wrapperClassNames.add('d-flex');
			}

			return (
				<div className={[...wrapperClassNames].join(' ')}>
					<div
						id="spin360"
						className="fyu_container fyu_horizontal"
					/>
				</div>
			);
		} else {
			return null;
		}
	}
}

Homenet360Component.propTypes = {
	modalSettings: PropTypes.shape({
		videoIsOpen: PropTypes.bool,
		spin360IsOpen: PropTypes.bool
	}).isRequired,
	fyuseUid: PropTypes.string.isRequired,
	trackGa: PropTypes.func.isRequired
};

export default Homenet360Component;
